/**
 * Client for the priority-health "get form name" backend endpoint.
 *
 * @module getFormName
 */
import { getCurrentFacilityId } from "@risalabs_frontend_org/auth-wrapper";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

/**
 * Resolves the recommended PA form name for a given order, scoping the
 * lookup to the user's currently selected facility/org.
 *
 * @param orderId - Order identifier whose recommended form should be fetched
 * @returns Parsed JSON payload from `GET_FORM_NAME` (shape defined by the backend)
 * @throws Error when the response is non-OK or the network request fails
 */
export const getFormName = async (orderId: string) => {
  try {
    const token = await getBearerToken();
    const response = await fetch(API_ENDPOINTS.GET_FORM_NAME, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        order_id: orderId,
        org_id: getCurrentFacilityId(),
      }),
    });
    if (!response.ok) {
      throw new Error(`Failed to get form name for the order`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    logDataToConsole("error in getFormName", error);
    throw error;
  }
};
